import React from 'react';
import { useTranslation } from 'react-i18next';
import Popup from './Popup';
import { IconTypes, lang } from '../../utils/utils';
import CinedLogo from '../../assets/images/logo.svg';

export default function StreamingInformationPopup(props) {
    const { t, i18n } = useTranslation();

    return (
        <Popup maxWidth="md" {...props}>
            <div>
                <div className="centeredContainer column">
                    <div className="centeredContainer">
                        <img alt="CinEd Logo" src={CinedLogo} className="logo" />
                    </div>
                    <h2 lang={lang[i18n.language]} className="modalTitleTD h4Text">
                        {props.title}
                    </h2>
                    <h2 lang={lang[i18n.language]} className="bigText">
                        {props.subtitle}
                    </h2>
                    {props.list && (
                        <ul className="customList">
                            {props.list.map((key, index) => (
                                <li key={index} className="customListItem">
                                    <span className="bulletIcon">•</span>
                                    <span className="bulletText">{t(key)}</span>
                                </li>
                            ))}
                        </ul>
                    )}

                    {props.iconType === IconTypes.SUCCESS ? (
                        <>
                            <p className="normalText marginZero">{props.description}</p>
                        </>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
        </Popup>
    );
}
